const SUPABASE_URL = 'https://dqerhchmeqlaueduiacl.supabase.co';
const SUPABASE_PUBLISHABLE_KEY = 'sb_publishable_kE5OXb5EOFqxe9JzyWKMKw_U3k-GJcU';
const PICKS_TABLE = 'worldcup_2026_picks';

const defaultHeaders = {
    apikey: SUPABASE_PUBLISHABLE_KEY,
    Authorization: `Bearer ${SUPABASE_PUBLISHABLE_KEY}`,
    'Content-Type': 'application/json',
};

const toQueryString = (params) => new URLSearchParams(params).toString();

export const fetchWorldCup2026Picks = async () => {
    const query = toQueryString({
        select: '*',
        order: 'match_order.asc',
    });

    const response = await fetch(`${SUPABASE_URL}/rest/v1/${PICKS_TABLE}?${query}`, {
        method: 'GET',
        headers: defaultHeaders,
    });

    if (!response.ok) {
        const errorText = await response.text();

        if (
            errorText.includes(PICKS_TABLE) &&
            (errorText.includes('does not exist') || errorText.includes('Could not find the table'))
        ) {
            return [];
        }

        throw new Error('Unable to load World Cup predictions from Supabase.');
    }

    return response.json();
};

export const saveWorldCup2026Pick = async (payload) => {
    const response = await fetch(
        `${SUPABASE_URL}/rest/v1/${PICKS_TABLE}?on_conflict=user_slug,match_id`,
        {
            method: 'POST',
            headers: {
                ...defaultHeaders,
                Prefer: 'resolution=merge-duplicates,return=representation',
            },
            body: JSON.stringify(payload),
        }
    );

    if (!response.ok) {
        const errorText = await response.text();

        if (
            errorText.includes(PICKS_TABLE) &&
            (errorText.includes('does not exist') || errorText.includes('Could not find the table'))
        ) {
            throw new Error(`To save World Cup predictions, first run supabase/worldcup_2026.sql in Supabase.`);
        }

        throw new Error('Unable to save your World Cup prediction.');
    }

    const rows = await response.json();
    return rows[0];
};
